// 正则表达式常量
export const REGEX = {
    QQ: /^[1-9]{1}[0-9]{4,14}$/, // QQ号校验
    PHONE: /^1\d{10}$/, // 手机号校验
    WECHAT: /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/, // 微信号校验
    EMAIL: /^\w+(-+.\w+)*@\w+(-.\w+)*.\w+(-.\w+)*$/, // 邮箱校验
    COUNT: /^\d+$/, // 数量
};